import dateDifference from "./date-difference";

const replaceSeperator = (str = "") => {
    return (str || "").replace(/,/g, "");
};

// eslint-disable-next-line complexity
export default (deliveryData) => {
    const {  homeDelivery = {}, selfPickUp = {} } = deliveryData || {};
    const { deliveryDateRange = {}} = (Array.isArray(homeDelivery) && homeDelivery[0]) || {};
    const { deliveryDateRange: pickUpDateRange = {}, pickUpLocation = {} } = (Array.isArray(selfPickUp) && selfPickUp[0]) || {};
    const dateDiff = dateDifference(pickUpDateRange.fromDate);
    const deliveryTatLabel = deliveryDateRange.tat === 1 ? deliveryDateRange.from : `Between ${replaceSeperator(deliveryDateRange.from)} - ${ replaceSeperator(deliveryDateRange.to)}`;
    const pickupTatLabel = pickUpDateRange.tat === 1 ? pickUpDateRange.from : `Between ${replaceSeperator(pickUpDateRange.from)} - ${ replaceSeperator(pickUpDateRange.to)}`;
    const homeDeliveryRangeLabel = deliveryData.homeDelivery ? deliveryTatLabel : null;
    const pickupDeliveryRangeLabel = deliveryData.selfPickUp ? pickupTatLabel : null;

    return ({
        homeDelivery: homeDeliveryRangeLabel,
        pickupDelivery: pickupDeliveryRangeLabel,
        pickUpDeliveryLabel: dateDiff === 1 ? `From tomorrow ${replaceSeperator(pickUpDateRange.from)}` : pickupDeliveryRangeLabel,
        pickUpLocation
    });
};
// From tomorrow Wed 20 June
